/* =====================================================================
   AstaLab 2.0 — normalizeUtils.js (round alpha.2)

   Porting VERBATIM delle utility di normalizzazione della baseline
   1.3.0-beta.6 (astalab.html righe 248-345), usate da tutto il
   sottosistema catalogo/statistiche (obiettivo 5/8 del round): nessuna
   formula o regola di conversione riscritta, solo estratte in un modulo
   ES condiviso fra ArtifactDemoCatalogRepository e la business logic
   usata anche lato SupabaseCatalogRepository per i calcoli di sola
   lettura (coverage/missing-data — vedi ARCHITECTURE_2.md §"Dati
   globali vs dati dell'asta").

   `clamp`/`num`/`round1` NON sono riesportate qui: sono già in
   engine/astalabEngine.js (stesso identico corpo, portato nel round
   alpha.1) — importarle da lì invece di ridefinirle evita una copia
   duplicata della stessa funzione in due moduli.
   ===================================================================== */
import { clamp, num } from "../engine/astalabEngine.js";

let __c = 0;
function cnt(){ return (__c++).toString(36); }
export function uid(prefix){ return prefix+"_"+Math.random().toString(36).slice(2,10)+cnt(); }
export function nowISO(){ return new Date().toISOString(); }
export function normStr(s){ return String(s||"").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g,"").trim(); }

export function isPlainObject(v){ return v!=null && typeof v==="object" && !Array.isArray(v); }
export function toNum(v, fallback, min, max){
  let n = typeof v==="number" ? v : parseFloat(String(v==null?"":v).replace(",", "."));
  if(!isFinite(n)) n = fallback;
  if(min!=null) n = Math.max(min, n);
  if(max!=null) n = Math.min(max, n);
  return n;
}
export function toInteger(v, fallback, min, max){
  const n = toNum(v, fallback, null, null);
  const rounded = Math.round(n);
  return clamp(rounded, min!=null?min:-Infinity, max!=null?max:Infinity);
}
export function toNumOrNull(v, min, max){
  if(v===null || v===undefined || v==="") return null;
  const n = toNum(v, null, min, max);
  return (n===null || !isFinite(n)) ? null : n;
}
export function toIntegerOrNull(v, min, max){
  if(v===null || v===undefined || v==="") return null;
  const n = toNum(v, null, null, null);
  if(n===null || !isFinite(n)) return null;
  return clamp(Math.round(n), min!=null?min:-Infinity, max!=null?max:Infinity);
}
export function toBool(v, fallback){
  if(typeof v==="boolean") return v;
  if(v===1 || v==="1" || v==="true") return true;
  if(v===0 || v==="0" || v==="false") return false;
  return fallback===undefined ? false : !!fallback;
}
export function toStr(v, fallback){
  const fb = fallback===undefined ? "" : fallback;
  if(v==null) return fb;
  if(typeof v==="string") return v;
  if(typeof v==="number" || typeof v==="boolean") return String(v);
  return fb;
}
export function toEnum(v, allowed, fallback){ return allowed.includes(v) ? v : fallback; }
export { num };
